import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import SplashText from '../SplashText';
import Button from '../Button';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { getVideo } from '../../../../utils/videoDB';
import VideoPlayerMenu from './VideoPlayerMenu';
import { usePxToVw } from '../../../../hooks/usePxToVw';
import LanguageBox from '../../../Wayfinder/LanguageBox';
import WeatherWidget from '../../../WeatherWidget';
import WheelchairToggle from '../../../WheelchairToggle';
import timerManager from '../../../../utils/timerManager';

const MenuCatalouges = ({
  menu,
  clicked,
  handleTextClick,
  uploadedUrls,
  handleFinalAction,
  splashText,
  settings,
  videotime,
  subMenuSettings,
  numColumns,
  columnSpacing,
  enableOffset,
  leftOffset,
  topOffset,
  backToMenu,
  isSecondView,
  isthirdView,
  brandColor,
  resetSession,
  changeVideoFun,
  handleTopicTextClick,
  brandFont,
  rightOffset,
  lineHeight, // Added marginBottom property
  padding,
  fontSize,
  removeWhiteFlashOnVideo,
  disableAnimation = false,
  menuPopup,
  captionSettings,
  setIsCaptionOn,
  isCaptionOn,
  handleWayfinderButtonClick = null, // New prop for wayfinder handling (with default)
  toggleSkipAttractLoop,
  skipAttractLoop,
  enableAttractLoopSwitchOnMainMenu,
  enableVideoEndOffset,
  videoEndLeftOffset,
  videoEndRightOffset,
  videoEndTopOffset,
  clientUrl, // Add clientUrl prop for localStorage key
  disableAreYouTherePopup = false, // New prop to control popup
  enableInvisibleToggleButton = false, // New prop to enable invisible toggle button
  onSplashVideoUpdate = null, // New prop to update splash video settings


  fetchMedia,


  toggleState,
  setToggleState,
  handleInvisibleToggle,
  selectedLanguage,
  availableLanguages = [],
  onLanguageChange,
  getLanguageName,
  getLanguageFlag,
  languageOffsets = { left: 20, top: 50, right: null },
  languageCustomization = {},
  languageIcons = {},
  languageIconSizes = {},
  languageDisplayNames = {},

  enableVideoEndNavigation,
  videoEndNavigationMenuId,
  primaryMenu,
  primarySubMenu,
  subhandleTextClick,

  currentState = false,
  isLanguageLoading = false,

  weatherSettings = { enabled: false },
  wheelchairSettings = { enabled: false },
  wheelchairContentOffsetY = 20,
  isWheelchairMode = false, // NEW: Receive from parent
  onWheelchairToggle, // NEW: Receive handler from parent
}) => {
  const videoRef = useRef(null);

  console.log("✅ MenuCatalouges received offsets:", {
    leftOffset,
    topOffset,
    rightOffset,
    enableOffset,
    numColumns
  });



  const [showVideoEndMenu, setShowVideoEndMenu] = useState(false);

  const [playCount, setPlayCount] = useState(0);
  const [videoComplete, setVideoComplete] = useState(false);
  const [editOpen, setEditOpen] = useState(false);

  const [countdown, setCountdown] = useState(5);

  const { pxToVw, getMaxWidth } = usePxToVw();

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // Initialize disableBk from localStorage
  const getStorageKey = () => `disableBk_${clientUrl || 'default'}`;

  // Get toggle state from localStorage to determine which video to play
  // const [toggleState, setToggleState] = useState(() => {
  //   try {
  //     const stored = localStorage.getItem(getToggleStateKey());
  //     return stored === 'true'; // Convert string to boolean
  //   } catch (error) {
  //     console.error('Error reading toggle state from localStorage:', error);
  //     return false;
  //   }
  // });

  const [disableBk, setDisableBk] = useState(() => {
    try {
      const stored = localStorage.getItem(getStorageKey());
      return stored === 'true'; // Convert string to boolean
    } catch (error) {
      console.error('Error reading disableBk from localStorage:', error);
      return false;
    }
  });

  // Save disableBk to localStorage whenever it changes
  useEffect(() => {
    try {
      localStorage.setItem(getStorageKey(), disableBk.toString());
      console.log(`disableBk saved to localStorage for ${clientUrl}:`, disableBk);
    } catch (error) {
      console.error('Error saving disableBk to localStorage:', error);
    }
  }, [disableBk, clientUrl]);

  // Cleanup all timers on unmount
  useEffect(() => {
    return () => {
      timerManager.clearAll();
      console.log('🧹 MenuCatalouges: All timers cleaned up on unmount');
    };
  }, []);

  // Restart video when uploadedUrls or toggleState changes (after fetchMedia is called)
  useEffect(() => {
    // Only restart if we're on the main menu (not on second or third view)
    if (!isSecondView && !isthirdView && videoRef.current) {
      console.log('🎬 Video URLs or toggle state changed, restarting video...', {
        toggleState,
        splashVideoEnabled: uploadedUrls?.splashVideo?.enabled,
        splashVideoTwoEnabled: uploadedUrls?.splashVideoTwo?.enabled,
      });

      // Small delay to ensure DOM has updated
      timerManager.setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.pause();
          videoRef.current.currentTime = 0;
          videoRef.current.load();

          videoRef.current.onloadeddata = () => {
            videoRef.current.play().catch(err => {
              console.error('Error auto-playing video after toggle:', err);
            });
          };
        }
      }, 100, 'menuCatalouges-video-restart');
    }
  }, [uploadedUrls?.splashVideo?.fileUrl, uploadedUrls?.splashVideoTwo?.fileUrl]);

  // Helper function to handle button clicks with wayfinder support
  const handleButtonClick = async item => {
    console.log('Button clicked:', item);
    console.log('LinkedWayfinder:', item?.linkedWayfinder);

    // Check if this is a wayfinder button and handler is available
    if (item?.linkedWayfinder && item?.linkedWayfinder?.status && handleWayfinderButtonClick) {
      console.log('Wayfinder button detected');

      // Check for direct location navigation
      if (
        item.linkedWayfinder.directLocation?.status &&
        item.linkedWayfinder.directLocation?.location
      ) {
        console.log('Direct location navigation:', item.linkedWayfinder.directLocation.location);

        // Navigate directly to avatar screen for the specified location
        const wayfinderHandled = await handleWayfinderButtonClick({
          ...item,
          directLocationId: item.linkedWayfinder.directLocation.location,
          isDirectLocation: true,
          navigationType: 'directLocation',
        });

        if (wayfinderHandled) {
          return; // Exit early if wayfinder handled the click
        }
      }

      // Check for search page navigation
      else if (item.linkedWayfinder.searchPage?.status) {
        console.log('Search page navigation detected');

        // Navigate to search screen with location data
        const wayfinderHandled = await handleWayfinderButtonClick({
          ...item,
          navigationType: 'searchPage',
          isSearchPage: true,
        });

        if (wayfinderHandled) {
          return; // Exit early if wayfinder handled the click
        }
      }

      // Handle other wayfinder navigation types (categories, subcategories, locations)
      else {
        console.log('Other wayfinder navigation');
        const wayfinderHandled = await handleWayfinderButtonClick(item);
        if (wayfinderHandled) {
          return; // Exit early if wayfinder handled the click
        }
      }
    } else if (
      item?.linkedWayfinder &&
      item?.linkedWayfinder?.status &&
      !handleWayfinderButtonClick
    ) {
      console.error('Wayfinder button clicked but handleWayfinderButtonClick is not available!');
      console.error('This prop must be passed from the parent component.');
    }

    // Original button click logic for non-wayfinder buttons
    if (!item?.linkedTrivia) {
      handleTextClick(item?.id, item?.linkbtnId);
    } else {
      handleTopicTextClick(item?.id, item?.linkedTrivia);
    }
  };

  useEffect(() => {
    if (editOpen && countdown > 0) {
      timerManager.setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000, 'menuCatalouges-countdown');
      return () => timerManager.clearInterval('menuCatalouges-countdown'); // Cleanup function
    } else if (countdown === 0) {
      handleCountdownComplete();
    }
  }, [editOpen, countdown]);

  // const handleCountdownComplete = () => {
  //   console.log('Countdown finished! Perform action here.');
  //   // Close the dialog after countdown
  //   if (videoRef?.current) {
  //     videoRef.current.pause();
  //     videoRef.current.removeAttribute('src'); // Unset the video source first
  //     videoRef.current.load(); // Forces the video to unload
  //   }
  //   resetSession();
  // };

  const handleCountdownComplete = () => {
    console.log("Countdown finished! Perform action here.");
    // Close the dialog after countdown
    if (videoRef?.current) {
      videoRef.current.pause();
      videoRef.current.removeAttribute("src"); // Unset the video source first
      videoRef.current.load(); // Forces the video to unload
    }
    if (!disableBk) {
      resetSession();
    } else {
      setEditOpen(false);
    }
  };

  const modalClodeFun = () => {
    //setIsSecondView();

    setPlayCount(0);
    setVideoComplete(false);
    setEditOpen(false);
    setCountdown(5);

    if (!enableVideoEndOffset.current && !showVideoEndMenu) {
      changeVideoFun();

      // Use setTimeout to ensure state updates have propagated
      if (videoRef.current) {
        videoRef.current.pause(); // Pause in case it was playing
        videoRef.current.currentTime = 0;

        // Ensure video is loaded before playing
        videoRef.current.load(); // Reload video to apply source changes

        videoRef.current.onloadeddata = () => {
          videoRef.current.play();
        };
      }
    } else {
      timerManager.setTimeout(() => {
        if (currentState === true && enableInvisibleToggleButton) {
          setEditOpen(true);
        } else if (currentState === false && enableInvisibleToggleButton) {
          setEditOpen(false);
        } else {
          setEditOpen(true);
        }
      }, 30000, 'menuCatalouges-modal-reopen');
    }
    // setShowVideoEndMenu(false);
  };


  const handleAnimationComplete = index => {
    if (index === 0) {
      handleFinalAction();
      setPlayCount(0);
      setVideoComplete(false);
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
  };

  const handleVideoPlayPage = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.muted = false;
    }
  };

  console.log("videotime", videotime)

  const handleVideoEnd = () => {
    // videoRef.current.play();
    if (videotime === 0) {
      videoRef.current.play();
    } else if (playCount < videotime - 1) {
      setPlayCount((prevCount) => prevCount + 1);
      videoRef.current.play();
    } else {
      if (videoRef.current) {
        // Ensure no play() is called before pausing
        videoRef.current.pause();
        if (disableAreYouTherePopup) {
          videoRef.current.currentTime = videoRef.current.duration - 0.5;
        }
      }

      // Check if video end navigation is enabled
      if (enableVideoEndNavigation?.current && videoEndNavigationMenuId?.current) {
        console.log('Video end navigation enabled, navigating to menu:', videoEndNavigationMenuId.current);

        // Find the menu to navigate to
        const targetMenuId = videoEndNavigationMenuId.current;

        // Check if it's a primary menu
        const primaryMenuItem = primaryMenu?.find(m => m.id === targetMenuId);
        console.log("Primary menu item found:", primaryMenuItem);
        console.log("Available primary menus:", primaryMenu);

        if (primaryMenuItem) {
          console.log('Navigating to primary menu:', primaryMenuItem);
          // Call handleTextClick with the menu ID and linkbtnId
          handleTextClick(primaryMenuItem.id, targetMenuId);
          return;
        }

        // Check if it's a submenu
        const submenuItem = primarySubMenu?.find(s => s.id === targetMenuId);
        console.log("Submenu item found:", submenuItem);
        console.log("Available submenus:", primarySubMenu);

        if (submenuItem) {
          console.log('Navigating to submenu:', submenuItem.name);
          if (subhandleTextClick) {
            subhandleTextClick(submenuItem.id, submenuItem.linkbtnId);


          } else {
            handleTextClick(submenuItem.id, submenuItem.linkbtnId);
          }
          return;
        }

        console.warn('Target menu not found:', targetMenuId);
        console.warn('Available menus:', { primaryMenu, primarySubMenu });
      }

      // Check if popup is disabled
      if (disableAreYouTherePopup) {
        // Don't show popup, just pause on last frame and stay there
        console.log('Are You There popup is disabled - staying on last frame');
        return;
      }

      if (enableVideoEndOffset.current) {
        setShowVideoEndMenu(true);
      }

      if (enableVideoEndOffset.current) {
        timerManager.setTimeout(() => {
          if (currentState === true && enableInvisibleToggleButton) {
            setEditOpen(true);
          } else if (currentState === false && enableInvisibleToggleButton) {
            setEditOpen(false);
          } else {
            setEditOpen(true);
          }
        }, 30000, 'menuCatalouges-video-end-popup');
      } else {
        if (currentState === true && enableInvisibleToggleButton) {
          setEditOpen(true);
        } else if (currentState === false && enableInvisibleToggleButton) {
          setEditOpen(false);
        } else {
          setEditOpen(true);
        }
      }
    }
  };

  const backToMenufun = () => {
    setPlayCount(0);
    setVideoComplete(false);
    if (videoRef?.current) {
      videoRef.current.pause();
      videoRef.current.removeAttribute('src'); // Unset the video source first
      videoRef.current.load(); // Forces the video to unload
    }

    // if (videoRef.current) {
    //   videoRef.current.pause();
    //   videoRef.current.currentTime = 0;
    // }
    backToMenu();
  };

  useEffect(() => {
    if (clicked && disableAnimation) {
      handleFinalAction();
    }
  }, [clicked]);

  const handleAnimationCompleteDisabledAnimation = () => {
    setPlayCount(0);
    setVideoComplete(false);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  // Handler for invisible toggle button
  // const handleInvisibleToggle = async () => {
  //   try {
  //     // Get current toggle state from localStorage
  //     const toggleKey = `invisibleToggleState_${clientUrl || 'default'}`;
  //     const currentState = localStorage.getItem(toggleKey) === 'true';
  //     const newState = !currentState;

  //     console.log('Invisible toggle clicked:', { currentState, newState });

  //     // Save new state to localStorage
  //     localStorage.setItem(toggleKey, newState.toString());
  //     setToggleState(newState); // Update local state immediately

  //     // Call backend API to toggle features
  //     const response = await fetch('/api/toggle-menu-features', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({
  //         userId: clientUrl, // Using clientUrl as userId
  //         currentToggleState: newState,
  //       }),
  //     });

  //     if (response.ok) {
  //       // const result = await response.json();
  //       // console.log('Toggle successful:', result);

  //       // // Fetch updated toggle settings (splash videos and next navigation) - lightweight endpoint
  //       // const toggleSettingsResponse = await fetch(`/api/toggle-settings/${clientUrl}`);
  //       // if (toggleSettingsResponse.ok) {
  //       //   const toggleData = await toggleSettingsResponse.json();
  //       //   console.log('Fetched updated toggle settings:', toggleData);

  //       //   // Update splash video settings via callback
  //       //   if (typeof onSplashVideoUpdate === 'function' && toggleData.data?.splashVideoSettings) {
  //       //     onSplashVideoUpdate({
  //       //       splashVideo: toggleData.data.splashVideoSettings.splashVideo,
  //       //       splashVideoTwo: toggleData.data.splashVideoSettings.splashVideoTwo,
  //       //     });
  //       //   }

  //       //   // Note: Next navigation settings are stored in backend and will be 
  //       //   // fetched automatically when SubMenuPage components mount/update
  //       //   console.log('Next navigation settings updated for submenus:', 
  //       //     toggleData.data?.submenuIds?.length || 0);
  //       // } else {
  //       //   console.error('Failed to fetch updated toggle settings');
  //       // }

  //       // // Don't reload - let the toggle work instantly
  //       // // The changes will take effect immediately via localStorage and state update

  //       fetchMedia(clientUrl)
  //     } else {
  //       console.error('Toggle failed:', await response.text());
  //     }
  //   } catch (error) {
  //     console.error('Error toggling features:', error);
  //   }
  // };

  const renderButtons = () => {
    if (numColumns === 'center-single-row') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: `${pxToVw(columnSpacing)}`,
            width: '100%',
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                onClick: () => {
                  if (!item?.linkedTrivia) {
                    handleButtonClick(item);
                  } else {
                    handleTopicTextClick(item?.id, item?.linkedTrivia);
                  }
                  handleAnimationCompleteDisabledAnimation();
                },
              }
              : {
                custom: { index, type: clicked ? 'slideOut' : 'visible' },
                initial: 'hidden',
                animate: clicked ? 'slideOut' : 'visible',
                variants: {
                  hidden: custom => ({
                    x: item.side === 'left' ? '-100vw' : '100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  visible: custom => ({
                    x: 0,
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  slideOut: custom => ({
                    x: item.side === 'left' ? '-100vw' : '100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.2,
                    },
                  }),
                },

                onClick: () => {
                  if (!item?.linkedTrivia) {
                    handleButtonClick(item);
                  } else {
                    handleTopicTextClick(item?.id, item?.linkedTrivia);
                  }
                },
                onAnimationComplete: definition => {
                  if (definition === 'slideOut') {
                    handleAnimationComplete(index);
                  }
                },
              };
            return (
              <ButtonWrapper key={index} {...animationProps} className="text-item">
                <Button key={index} text={item?.name} settings={item?.settings} keyid={item?.id} />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (numColumns === 'unlimited-buttons-center') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: `${pxToVw(columnSpacing)}`,
            // width: '100%',
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                onClick: () => {
                  handleButtonClick(item);
                  handleAnimationCompleteDisabledAnimation();
                },
              }
              : {
                custom: { index, type: clicked ? 'slideOut' : 'visible' },
                initial: 'hidden',
                animate: clicked ? 'slideOut' : 'visible',
                variants: {
                  hidden: custom => ({
                    x: item.side === 'left' ? '-100vw' : '100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  visible: custom => ({
                    x: 0,
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  slideOut: custom => ({
                    x: item.side === 'left' ? '-100vw' : '100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.2,
                    },
                  }),
                },
                // className="text-item"
                onClick: () => handleButtonClick(item),
                onAnimationComplete: definition => {
                  if (definition === 'slideOut') {
                    handleAnimationComplete(index);
                  }
                },
              };
            return (
              <ButtonWrapper
                key={index}
                {...animationProps}
                className="text-item"
                style={{ width: 'unset !Important' }}

              // onClick={() => handleButtonClick(item)}
              >
                <Button key={index} text={item?.name} settings={item?.settings} keyid={item?.id} />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (numColumns === 'unlimited-left-buttons-center') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: `${pxToVw(columnSpacing)}`,
            // width: '100%',
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                onClick: () => {
                  handleButtonClick(item);
                  handleAnimationCompleteDisabledAnimation();
                },
              }
              : {
                custom: { index, type: clicked ? 'slideOut' : 'visible' },
                initial: 'hidden',
                animate: clicked ? 'slideOut' : 'visible',
                variants: {
                  hidden: custom => ({
                    x: '-100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  visible: custom => ({
                    x: 0,
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  slideOut: custom => ({
                    x: '-100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.2,
                    },
                  }),
                },
                // className="text-item"
                onClick: () => handleButtonClick(item),
                onAnimationComplete: definition => {
                  if (definition === 'slideOut') {
                    handleAnimationComplete(index);
                  }
                },
              };
            return (
              <ButtonWrapper
                key={index}
                {...animationProps}
                className="text-item"
                style={{ width: 'unset !Important' }}

              // onClick={() => handleButtonClick(item)}
              >
                <Button key={index} text={item?.name} settings={item?.settings} keyid={item?.id} />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (numColumns === 'unlimited-right-buttons-center') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: `${pxToVw(columnSpacing)}`,
            // width: '100%',
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                onClick: () => {
                  handleButtonClick(item);
                  handleAnimationCompleteDisabledAnimation();
                },
              }
              : {
                custom: { index, type: clicked ? 'slideOut' : 'visible' },
                initial: 'hidden',
                animate: clicked ? 'slideOut' : 'visible',
                variants: {
                  hidden: custom => ({
                    x: '100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  visible: custom => ({
                    x: 0,
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  slideOut: custom => ({
                    x: '100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.2,
                    },
                  }),
                },
                // className="text-item"
                onClick: () => handleButtonClick(item),
                onAnimationComplete: definition => {
                  if (definition === 'slideOut') {
                    handleAnimationComplete(index);
                  }
                },
              };
            return (
              <ButtonWrapper
                key={index}
                {...animationProps}
                className="text-item"
                style={{ width: 'unset !Important' }}

              // onClick={() => handleButtonClick(item)}
              >
                <Button key={index} text={item?.name} settings={item?.settings} keyid={item?.id} />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (numColumns === 'center-two-buttons-per-row') {
      const leftButtons = (menu || []).filter(item => item.side === 'left');
      const rightButtons = (menu || []).filter(item => item.side === 'right');

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: `${pxToVw(columnSpacing)}`,
            width: '100%',
          }}
        >
          {/* Left Column */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: `${pxToVw(columnSpacing)}`,
              width: '100%',
            }}
          >
            {leftButtons.map((item, index) => {
              const ButtonWrapper = disableAnimation ? 'div' : motion.div;
              const animationProps = disableAnimation
                ? {
                  onClick: () => {
                    if (!item?.linkedTrivia) {
                      handleButtonClick(item);
                    } else {
                      handleTopicTextClick(item?.id, item?.linkedTrivia);
                    }
                    handleAnimationCompleteDisabledAnimation();
                  },
                }
                : {
                  custom: { index, direction: 'left' },
                  initial: 'hidden',
                  animate: clicked ? 'slideOut' : 'visible',
                  variants: {
                    hidden: custom => ({
                      x: '-100vw',
                      opacity: 1,
                      scale: 0.95,
                      transition: {
                        type: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.15,
                      },
                    }),
                    visible: custom => ({
                      x: 0,
                      opacity: 1,
                      scale: 1,
                      transition: {
                        ease: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.15,
                      },
                    }),
                    slideOut: custom => ({
                      x: '-100vw',
                      opacity: 0,
                      scale: 0.95,
                      transition: {
                        ease: 'easeInOut',
                        duration: 1,
                        delay: 1 + (leftButtons.length - 1 - custom.index) * 0.15,
                      },
                    }),
                  },

                  onClick: () => {
                    if (!item?.linkedTrivia) {
                      handleButtonClick(item);
                    } else {
                      handleTopicTextClick(item?.id, item?.linkedTrivia);
                    }
                  },
                  onAnimationComplete: definition => {
                    if (definition === 'slideOut') {
                      handleAnimationComplete(index);
                    }
                  },
                };
              return (
                <ButtonWrapper key={index} {...animationProps} className="text-item">
                  <Button
                    key={index}
                    text={item?.name}
                    settings={item?.settings}
                    keyid={item?.id}
                  />
                </ButtonWrapper>
              );
            })}
          </div>

          {/* Right Column */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: `${pxToVw(columnSpacing)}`,
              width: '100%',
            }}
          >
            {rightButtons.map((item, index) => {
              const ButtonWrapper = disableAnimation ? 'div' : motion.div;
              const animationProps = disableAnimation
                ? {
                  onClick: () => {
                    if (!item?.linkedTrivia) {
                      handleButtonClick(item);
                    } else {
                      handleTopicTextClick(item?.id, item?.linkedTrivia);
                    }
                    handleAnimationCompleteDisabledAnimation();
                  },
                }
                : {
                  custom: { index, direction: 'right' },
                  initial: 'hidden',
                  animate: clicked ? 'slideOut' : 'visible',
                  variants: {
                    hidden: custom => ({
                      x: '100vw',
                      opacity: 1,
                      scale: 0.95,
                      transition: {
                        type: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.15,
                      },
                    }),
                    visible: custom => ({
                      x: 0,
                      opacity: 1,
                      scale: 1,
                      transition: {
                        ease: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.15,
                      },
                    }),
                    slideOut: custom => ({
                      x: '100vw',
                      opacity: 0,
                      scale: 0.95,
                      transition: {
                        ease: 'easeInOut',
                        duration: 1,
                        delay: 1 + (rightButtons.length - 1 - custom.index) * 0.15,
                      },
                    }),
                  },

                  onClick: () => {
                    if (!item?.linkedTrivia) {
                      handleButtonClick(item);
                    } else {
                      handleTopicTextClick(item?.id, item?.linkedTrivia);
                    }
                  },
                  onAnimationComplete: definition => {
                    if (definition === 'slideOut') {
                      handleAnimationComplete(index);
                    }
                  },
                };
              return (
                <ButtonWrapper key={index} {...animationProps} className="text-item">
                  <Button
                    key={index}
                    text={item?.name}
                    settings={item?.settings}
                    keyid={item?.id}
                  />
                </ButtonWrapper>
              );
            })}
          </div>
        </div>
      );
    } else if (numColumns === 'right-side-one-button-per-row') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: `${pxToVw(columnSpacing)}`,
            width: '100%',
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                onClick: () => {
                  if (!item?.linkedTrivia) {
                    handleButtonClick(item);
                  } else {
                    handleTopicTextClick(item?.id, item?.linkedTrivia);
                  }
                  handleAnimationCompleteDisabledAnimation();
                },
              }
              : {
                custom: { index, direction: 'right' },
                initial: 'hidden',
                animate: clicked ? 'slideOut' : 'visible',
                variants: {
                  hidden: custom => ({
                    x: '100vw',
                    opacity: 1,
                    scale: 0.95,
                    transition: {
                      type: 'easeInOut',
                      damping: 30,
                      duration: 1,
                      stiffness: 20,
                      delay: custom.index * 0.15,
                    },
                  }),
                  visible: custom => ({
                    x: 0,
                    opacity: 1,
                    scale: 1,
                    transition: {
                      ease: 'easeInOut',
                      damping: 30,
                      duration: 1,
                      stiffness: 20,
                      delay: custom.index * 0.1,
                    },
                  }),
                  slideOut: custom => ({
                    x: '100vw',
                    opacity: 0,
                    scale: 0.95,
                    transition: {
                      ease: 'easeInOut',
                      duration: 1,
                      delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.15,
                    },
                  }),
                },

                onClick: () => {
                  if (!item?.linkedTrivia) {
                    handleButtonClick(item);
                  } else {
                    handleTopicTextClick(item?.id, item?.linkedTrivia);
                  }
                },
                onAnimationComplete: definition => {
                  if (definition === 'slideOut') {
                    handleAnimationComplete(index);
                  }
                },
              };
            return (
              <ButtonWrapper key={index} {...animationProps} className="text-item">
                <Button key={index} text={item?.name} settings={item?.settings} keyid={item?.id} />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (numColumns === 'left-side-one-button-per-row') {
      const sortedMenuu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: `${pxToVw(columnSpacing)}`,
            width: '100%',
          }}
        >
          {sortedMenuu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                onClick: () => {
                  if (!item?.linkedTrivia) {
                    handleButtonClick(item);
                  } else {
                    handleTopicTextClick(item?.id, item?.linkedTrivia);
                  }
                  handleAnimationCompleteDisabledAnimation();
                },
              }
              : {
                custom: { index },
                initial: 'hidden',
                animate: clicked ? 'slideOut' : 'visible',
                exit: 'slideOut', // Ensures exit animation is applied
                variants: {
                  hidden: custom => ({
                    x: '-100vw',
                    opacity: 1,
                    scale: 0.95,
                    transition: {
                      type: 'easeInOut',
                      damping: 30,
                      duration: 1,
                      stiffness: 20,
                      delay: custom.index * 0.15,
                    },
                  }),
                  visible: custom => ({
                    x: 0,
                    opacity: 1,
                    scale: 1,
                    transition: {
                      ease: 'easeInOut',
                      damping: 30,
                      duration: 1,
                      stiffness: 20,
                      delay: custom.index * 0.1,
                    },
                  }),
                  slideOut: custom => ({
                    x: '-100vw',
                    opacity: 0,
                    scale: 0.95,
                    transition: {
                      ease: 'easeInOut',
                      duration: 1,
                      delay: 1 + (sortedMenuu.length - 1 - custom.index) * 0.15,
                    },
                  }),
                },

                onClick: () => {
                  if (!item?.linkedTrivia) {
                    handleButtonClick(item);
                  } else {
                    handleTopicTextClick(item?.id, item?.linkedTrivia);
                  }
                },
                onAnimationComplete: definition => {
                  if (definition === 'slideOut') {
                    handleAnimationComplete(index);
                  }
                },
              };
            return (
              <ButtonWrapper key={index} {...animationProps} className="text-item">
                <Button key={index} text={item?.name} settings={item?.settings} keyid={item?.id} />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    }
  };

  // Track window size for responsiveness
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Responsive padding calculation
  const getResponsivePadding = () => {
    if (windowSize.width < 768) return '8px';
    if (windowSize.width < 1200) return '12px';
    return '15px';
  };

  // Responsive margin calculation
  const getResponsiveMargin = () => {
    if (windowSize.width < 768) return '10px';
    if (windowSize.width < 1200) return '15px';
    return '20px';
  };

  // Responsive logo size calculation
  const getResponsiveLogoSize = baseSize => {
    if (windowSize.width < 480) return Math.min(baseSize, 80);
    if (windowSize.width < 768) return Math.min(baseSize, 100);
    if (windowSize.width < 1200) return Math.min(baseSize, 120);
    return Math.min(baseSize, 150);
  };

  const motionProps = removeWhiteFlashOnVideo
    ? {}
    : {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      transition: { duration: 2 },
    };

  // Check if there are any videos available
  const hasVideos = () => {
    return (
      (uploadedUrls?.splashVideo?.fileUrl && uploadedUrls?.splashVideo?.enabled) ||
      (uploadedUrls?.splashVideotwo?.fileUrl && uploadedUrls?.splashVideotwo?.enabled) ||
      (uploadedUrls?.splashVideothree?.fileUrl && uploadedUrls?.splashVideothree?.enabled)
    );
  };

  // Effect for menu popup when no videos are present
  useEffect(() => {
    // Don't set up popup if it's disabled
    if (disableAreYouTherePopup) {
      return;
    }

    if (menuPopup && menuPopup > 0 && !hasVideos()) {
      // Convert menuPopup seconds to milliseconds
      const intervalTime = menuPopup * 1000;

      timerManager.setInterval(() => {
        if (currentState === true && enableInvisibleToggleButton) {
          setEditOpen(true);
        } else if (currentState === false && enableInvisibleToggleButton) {
          setEditOpen(false);
        } else {
          setEditOpen(true);
        }
        //setCountdown(5); // Reset countdown each time popup opens
      }, intervalTime, 'menuCatalouges-popup-interval');

      console.log(`Menu popup interval set for ${menuPopup} seconds`);
    }

    // Cleanup interval on component unmount or when dependencies change
    return () => {
      timerManager.clearInterval('menuCatalouges-popup-interval');
    };
  }, [menuPopup, uploadedUrls, disableAreYouTherePopup]); // Re-run when menuPopup, uploadedUrls, or disableAreYouTherePopup change

  // make sure dependencies are correct

  // Toggle play/pause on invisible click area
  const handleInvisiblePlayPause = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  };

  const toggleSkipAttractLoopBack = () => {
    setDisableBk(!disableBk);
  }

  return (
    <div className="">
      {/* Invisible play/pause area (top 200px of screen) */}
      {/* <div
        onClick={handleInvisiblePlayPause}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '200px',
          cursor: 'pointer',
          background: 'transparent',
          zIndex: 8888, // make sure it's above video
        }}
      /> */}

      <>
        {enableAttractLoopSwitchOnMainMenu && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: '150px',
              height: '100px',
              cursor: 'pointer',
              background: 'transparent',
              zIndex: 9999,
              opacity: 0,
            }}
            onClick={toggleSkipAttractLoopBack}
          >
            Skip
          </div>
        )}

        {/* Invisible Toggle Button - Upper Left Corner */}
        {enableInvisibleToggleButton && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '150px',
              height: '100px',
              cursor: 'pointer',
              background: 'transparent',
              zIndex: 9999,
              opacity: 0,
            }}
            onClick={handleInvisibleToggle}
          >
            Toggle
          </div>
        )}
      </>

      

      {/* First Video - switches between splashVideo and splashVideoTwo based on toggle state */}
      {/* 
      {((!isSecondView && !isthirdView) ||
        (isSecondView && !uploadedUrls?.splashVideotwo?.enabled) ||
        (isthirdView && !uploadedUrls?.splashVideothree?.enabled)) &&
        (toggleState ? uploadedUrls?.splashVideoTwo?.enabled : uploadedUrls?.splashVideo?.enabled) ? (
        <AnimatePresence mode="wait">
          <VideoPlayerMenu
            videoRef={videoRef}
            videoKey={uploadedUrls?.splashVideo?.fileUrl}
            handleVideoPlayPage={handleVideoPlayPage}
            handleVideoEnd={handleVideoEnd}
            removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
            captionFileUrl={toggleState ? uploadedUrls?.splashVideoTwo?.captionFile : uploadedUrls?.splashVideo?.captionFile}
            captionSettings={captionSettings}
            setIsCaptionOn={setIsCaptionOn}
            isCaptionOn={isCaptionOn}
          />
        </AnimatePresence>
      ) : (
        ''
      )} */}


      {((!isSecondView && !isthirdView) ||
        (isSecondView && !uploadedUrls?.splashVideotwo?.enabled) ||
        (isthirdView && !uploadedUrls?.splashVideothree?.enabled)) &&
        uploadedUrls?.splashVideo?.enabled && (
          (
            <AnimatePresence mode="wait">
              <VideoPlayerMenu
                videoRef={videoRef}
                videoKey={`${uploadedUrls?.splashVideo?.fileUrl}_${selectedLanguage}`}
                handleVideoPlayPage={handleVideoPlayPage}
                handleVideoEnd={handleVideoEnd}
                removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
                captionFileUrl={toggleState ? uploadedUrls?.splashVideoTwo?.captionFile : uploadedUrls?.splashVideo?.captionFile}
                captionSettings={captionSettings}
                setIsCaptionOn={setIsCaptionOn}
                isCaptionOn={isCaptionOn}
              />
            </AnimatePresence>
          ))}

      {/* Second Video */}

      {isSecondView && uploadedUrls?.splashVideotwo?.enabled ? (
        <AnimatePresence mode="wait">
          <VideoPlayerMenu
            videoRef={videoRef}
            videoKey={`${uploadedUrls?.splashVideotwo?.fileUrl}_${selectedLanguage}`}
            handleVideoPlayPage={handleVideoPlayPage}
            handleVideoEnd={handleVideoEnd}
            removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
            captionFileUrl={
              uploadedUrls?.splashVideotwo?.captionFile && uploadedUrls?.splashVideotwo?.captionFile
            }
            captionSettings={captionSettings}
            setIsCaptionOn={setIsCaptionOn}
            isCaptionOn={isCaptionOn}
          />
        </AnimatePresence>
      ) : (
        ''
      )}

      {isthirdView && uploadedUrls?.splashVideothree?.enabled ? (
        <AnimatePresence mode="wait">
          <VideoPlayerMenu
            videoRef={videoRef}
            videoKey={`${uploadedUrls?.splashVideothree?.fileUrl}_${selectedLanguage}`}
            handleVideoPlayPage={handleVideoPlayPage}
            handleVideoEnd={handleVideoEnd}
            removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
            captionFileUrl={
              uploadedUrls?.splashVideothree?.captionFile &&
              uploadedUrls?.splashVideothree?.captionFile
            }
            captionSettings={captionSettings}
            setIsCaptionOn={setIsCaptionOn}
            isCaptionOn={isCaptionOn}
          />
        </AnimatePresence>
      ) : (
        ''
      )}

      <div className="corner-overlays-responsive">
        {/* Top Left Logo */}
        <AnimatePresence mode="wait">
          <motion.div
            {...motionProps}
            className="corner-item top-left"
            style={{ justifyContent: 'left' }}
          >
            <img
              src={uploadedUrls?.leftTop?.fileUrl}
              alt="Logo"
              style={{
                display: uploadedUrls?.leftTop?.enabled ? 'block' : 'none',
                // width: uploadedUrls?.leftTop?.width > 0 ?
                //   `${pxToVw(uploadedUrls.leftTop.width)}` : 'auto',
                // height: uploadedUrls?.leftTop?.height > 0 ?
                //   `${pxToVw(uploadedUrls.leftTop.height)}` : 'auto',
                // maxWidth: '25vw',
                // maxHeight: '25vw'
                maxWidth: `${uploadedUrls.leftTop.width > 0 ? '100vw' : getMaxWidth('25vw')}`,
                width: uploadedUrls?.leftTop?.width > 0 ? `${uploadedUrls.leftTop.width}%` : 'auto',
                height: 'auto',
              }}
            />
          </motion.div>
        </AnimatePresence>

        {/* Back Button */}
        {!disableBk && (
          <AnimatePresence mode="wait">
            <motion.div {...motionProps} className="corner-item back-button">
              <img
                src={uploadedUrls?.backMenuMedia?.fileUrl}
                alt="Back"
                style={{
                  display: uploadedUrls?.backMenuMedia?.enabled ? 'block' : 'none',
                  cursor: 'pointer',
                  // maxWidth: uploadedUrls?.backMenuMedia?.width > 0 ? 'unset' : getMaxWidth('30vw'),
                  // maxHeight: uploadedUrls?.backMenuMedia?.height > 0 ? 'unset' : getMaxWidth('30vw'),
                  width:
                    uploadedUrls?.backMenuMedia?.width > 0
                      ? `${uploadedUrls.backMenuMedia.width}%`
                      : 'auto',
                  // height: "15vw"
                }}
                onClick={() => backToMenufun()}
              />
            </motion.div>
          </AnimatePresence>
        )}

        {/* Top Right Logo */}
        <AnimatePresence mode="wait">
          <motion.div
            {...motionProps}
            className="corner-item top-right"
            style={{ justifyContent: 'right' }}
          >
            <img
              src={uploadedUrls?.rightTop?.fileUrl}
              alt="Logo"
              style={{
                display: uploadedUrls?.rightTop?.enabled ? 'block' : 'none',
                // width: uploadedUrls?.rightTop?.width > 0 ?
                //   `${pxToVw(uploadedUrls.rightTop.width)}` : 'auto',
                // height: uploadedUrls?.rightTop?.height > 0 ?
                //   `${pxToVw(uploadedUrls.rightTop.height)}` : 'auto',
                // maxWidth: '25vw',
                // maxHeight: '25vw'
                maxWidth: `${uploadedUrls.rightTop.width > 0 ? '100%' : getMaxWidth('25vw')}`,
                width:
                  uploadedUrls?.rightTop?.width > 0 ? `${uploadedUrls.rightTop.width}%` : 'auto',
                height: 'auto',
              }}
            />
          </motion.div>
        </AnimatePresence>

        {/* Bottom Right Logo */}
        <AnimatePresence mode="wait">
          <motion.div
            {...motionProps}
            className="corner-item bottom-right"
            style={{ justifyContent: 'right' }}
          >
            <img
              src={uploadedUrls?.rightBottom?.fileUrl}
              alt="Logo"
              style={{
                display: uploadedUrls?.rightBottom?.enabled ? 'block' : 'none',
                // width: uploadedUrls?.rightBottom?.width > 0 ?
                //   `${pxToVw(uploadedUrls.rightBottom.width)}` : 'auto',
                // height: uploadedUrls?.rightBottom?.height > 0 ?
                //   `${pxToVw(uploadedUrls.rightBottom.height)}` : 'auto',
                //  maxWidth: '25vw',
                // maxHeight: '25vw'
                maxWidth: `${uploadedUrls.rightBottom.width > 0 ? '100%' : getMaxWidth('25vw')}`,
                width:
                  uploadedUrls?.rightBottom?.width > 0
                    ? `${uploadedUrls.rightBottom.width}%`
                    : 'auto',
                height: 'auto',
              }}
            />
          </motion.div>
        </AnimatePresence>
        {/* Bottom Left Logo */}
        <AnimatePresence mode="wait">
          <motion.div
            {...motionProps}
            className="corner-item bottom-left"
            style={{ justifyContent: 'left' }}
          >
            <img
              src={uploadedUrls?.leftBottom?.fileUrl}
              alt="Logo"
              style={{
                display: uploadedUrls?.leftBottom?.enabled ? 'block' : 'none',
                // width: uploadedUrls?.leftBottom?.width > 0 ?
                //   `${pxToVw(uploadedUrls.leftBottom.width)}` : 'auto',
                // height: uploadedUrls?.leftBottom?.height > 0 ?
                //   `${pxToVw(uploadedUrls.leftBottom.height)}` : 'auto',
                // maxWidth: '25vw',
                // maxHeight: '25vw'
                maxWidth: `${uploadedUrls.leftBottom.width > 0 ? '100%' : getMaxWidth('25vw')}`,
                width:
                  uploadedUrls?.leftBottom?.width > 0
                    ? `${uploadedUrls.leftBottom.width}%`
                    : 'auto',
                height: 'auto',
              }}
            />
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Language Selector - Using LanguageBox Component */}
      {availableLanguages && availableLanguages.length > 1 && (
        <div
          style={{
            position: 'absolute',
            left: languageOffsets.right ? 'auto' : `${languageOffsets.left}%`,
            right: languageOffsets.right ? `${languageOffsets.right}%` : 'auto',
            top: `${languageOffsets.top || 10}%`,
            transform: 'translateY(-50%)',
            zIndex: 1000,
            display: 'flex',
            flexDirection: 'column',
            gap: pxToVw(languageCustomization.gap || 10),
            background: `rgba(${parseInt((languageCustomization.outerBackgroundColor || '#808080').slice(1, 3), 16)}, ${parseInt((languageCustomization.outerBackgroundColor || '#808080').slice(3, 5), 16)}, ${parseInt((languageCustomization.outerBackgroundColor || '#808080').slice(5, 7), 16)}, ${(languageCustomization.outerOpacity || 100) / 100})`,
            padding: pxToVw(languageCustomization.outerPadding || 15),
            borderRadius: pxToVw(languageCustomization.outerBorderRadius || 15),
            border: `${pxToVw(languageCustomization.outerBorderWidth)} solid ${languageCustomization.outerBorderColor || '#ffffff'}`,
            boxShadow: (() => {
              const h = languageCustomization.outerShadowH || 0;
              const v = languageCustomization.outerShadowV || 4;
              const blur = languageCustomization.outerShadowBlur || 20;
              const spread = languageCustomization.outerShadowSpread || 0;
              const color = languageCustomization.outerShadowColor || '#000000';
              const opacity = languageCustomization.outerShadowOpacity || 40;
              const r = parseInt(color.slice(1, 3), 16);
              const g = parseInt(color.slice(3, 5), 16);
              const b = parseInt(color.slice(5, 7), 16);
              return `${h}px ${v}px ${blur}px ${spread}px rgba(${r}, ${g}, ${b}, ${opacity / 100})`;
            })(),
            width: languageCustomization.outerWidth ? pxToVw(languageCustomization.outerWidth) : 'auto',
            height: languageCustomization.outerHeight ? pxToVw(languageCustomization.outerHeight) : 'auto',
          }}
        >
          {availableLanguages.map((lang) => {
            const languageInfo = {
              code: lang,
              name: getLanguageName ? getLanguageName(lang) : lang.toUpperCase(),
              flag: getLanguageFlag ? getLanguageFlag(lang) : lang,
            };

            return (
              <LanguageBox
                key={lang}
                language={languageInfo}
                customization={languageCustomization}
                isSelected={lang === selectedLanguage}
                onClick={() => {
                  if (onLanguageChange) {
                    onLanguageChange(lang);
                  }
                }}
                size="normal"
                customIconUrl={languageIcons[lang]}
                customIconSize={languageIconSizes[lang]}
                customDisplayName={languageDisplayNames[lang]}
              />
            );
          })}
        </div>
      )}

      {/* Weather Widget */}
      {weatherSettings?.enabled && weatherSettings?.visibility?.mainMenu && (
        <div
          style={{
            position: 'absolute',
            top: weatherSettings.positionTop !== null && weatherSettings.positionTop !== undefined ? `${weatherSettings.positionTop}%` : 'auto',
            bottom: weatherSettings.positionBottom !== null && weatherSettings.positionBottom !== undefined ? `${weatherSettings.positionBottom}%` : 'auto',
            // Center mode: anchor to 50% left and shift back with translateX(-50%)
            ...(weatherSettings.horizontalAlign === 'center'
              ? { left: '50%', right: 'auto', transform: 'translateX(-50%)' }
              : {
                left: weatherSettings.positionLeft !== null && weatherSettings.positionLeft !== undefined ? `${weatherSettings.positionLeft}%` : 'auto',
                right: weatherSettings.positionRight !== null && weatherSettings.positionRight !== undefined ? `${weatherSettings.positionRight}%` : 'auto',
              }
            ),
            zIndex: 1000,
          }}
        >
          <WeatherWidget
            apiKey={weatherSettings.weatherApiKey}
            latitude={weatherSettings.latitude}
            longitude={weatherSettings.longitude}
            forecastDays={weatherSettings.forecastDays || 3}
            temperatureUnit={weatherSettings.temperatureUnit || 'both'}
            celsiusFirst={weatherSettings.celsiusFirst !== false}
            showLocation={weatherSettings.showLocation || false}
            showClock={weatherSettings.showClock !== false}
            showCurrentWeather={weatherSettings.showCurrentWeather !== false}
            showForecast={weatherSettings.showForecast !== false}
            widgetOrder={weatherSettings.widgetOrder || ['clock', 'current', 'forecast']}
            backgroundColor={weatherSettings.backgroundColor || '#ffffff'}
            backgroundOpacity={weatherSettings.backgroundOpacity ?? 80}
            textColor={weatherSettings.textColor || '#1a202c'}
            subTextColor={weatherSettings.subTextColor || '#718096'}
            padding={weatherSettings.padding ?? 16}
            borderRadius={weatherSettings.borderRadius ?? 12}
            width={weatherSettings.width || 0}
            fontFamily={weatherSettings.fontFamily === 'inherit' || !weatherSettings.fontFamily ? brandFont || 'inherit' : weatherSettings.fontFamily}
            fontSize={weatherSettings.fontSize || 14}
            iconSize={weatherSettings.iconSize || 40}
            forecastIconSize={weatherSettings.forecastIconSize || 28}
            shadowH={weatherSettings.shadowH ?? 0}
            shadowV={weatherSettings.shadowV ?? 4}
            shadowBlur={weatherSettings.shadowBlur ?? 12}
            shadowSpread={weatherSettings.shadowSpread ?? 0}
            shadowColor={weatherSettings.shadowColor || '#000000'}
            shadowOpacity={weatherSettings.shadowOpacity ?? 15}
            useVwSizing={true}
          />
        </div>
      )}

      {/* Wheelchair Toggle Button */}
      <WheelchairToggle
        settings={wheelchairSettings}
        isActive={isWheelchairMode}
        onClick={onWheelchairToggle}
      />

      <motion.div
        className="responsive-menu-containerr"
        key={`menu-${leftOffset}-${topOffset}-${rightOffset}-${enableOffset}`}
        initial={{
          top:
            showVideoEndMenu && enableVideoEndOffset?.current
              ? `${videoEndTopOffset.current}%`
              : enableOffset
                ? `${topOffset + (isWheelchairMode ? wheelchairContentOffsetY : 0)}%`
                : (isWheelchairMode ? `${wheelchairContentOffsetY}%` : 0),

          left:
            showVideoEndMenu && enableVideoEndOffset?.current
              ? `${videoEndLeftOffset.current > 0 ? videoEndLeftOffset.current + '%' : 'unset'}`
              
              : enableOffset
                ? `${leftOffset}%`
                : 0,

          right:
            showVideoEndMenu && enableVideoEndOffset?.current
              ? `${videoEndRightOffset.current > 0 ? videoEndRightOffset.current + '%' : 'unset'}`
              : enableOffset
                ? `${rightOffset}%`
                : 0,
        }}
        animate={{
          top:
            showVideoEndMenu && enableVideoEndOffset?.current
              ? `${videoEndTopOffset.current}%`
              : enableOffset
                ? `${topOffset + (isWheelchairMode ? wheelchairContentOffsetY : 0)}%`
                : (isWheelchairMode ? `${wheelchairContentOffsetY}%` : 0),

          left:
            showVideoEndMenu && enableVideoEndOffset?.current
              ? `${videoEndLeftOffset.current > 0 ? videoEndLeftOffset.current + '%' : 'unset'}`
              
              : enableOffset
                ? `${leftOffset}%`
                : 0,

          right:
            showVideoEndMenu && enableVideoEndOffset?.current
              ? `${videoEndRightOffset.current > 0 ? videoEndRightOffset.current + '%' : 'unset'}`
              : enableOffset
                ? `${rightOffset}%`
                : 0,
        }}

        transition={{
          opacity: {
            times: [0, 0.3, 0.6, 1],
            duration: 1.2,
            ease: 'easeInOut',
          },

          top: {
            duration: 0,
            ease: 'easeInOut',
          },

          left: {
            duration: 0,
            ease: 'easeInOut',
          },

          right: {
            duration: 0,
            ease: 'easeInOut',
          },
        }}
        style={{
          position: "absolute",
          width: enableOffset ? "auto" : "100%",
          height: enableOffset ? "auto" : "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2,
          padding: "2%",
          boxSizing: "border-box",
        }}
      >
        {/* Center Logo */}
        <AnimatePresence mode="wait">
          
          <motion.div {...motionProps} className="center-logo-container">
            <img
              src={uploadedUrls?.centerLogo?.fileUrl}
              alt="Logo"
              style={{
                maxWidth: showVideoEndMenu && enableVideoEndOffset.current ? '50vw' : 'auto',
                marginBottom: getResponsiveMargin(),
                display: uploadedUrls?.centerLogo?.enabled ? "block" : "none",
                // maxWidth: '35vw',
                // maxHeight: '35vw',
                width:
                  uploadedUrls?.centerLogo?.width > 0
                    ? `${uploadedUrls.centerLogo.width}%`
                    : "auto",
                height: "auto",

                maxWidth:
                  showVideoEndMenu && enableVideoEndOffset.current
                    ? "50vw"
                    : "auto",
              }}
            />
          </motion.div>
        </AnimatePresence>

        <SplashText
          text={splashText || "Splash Text"}
          settings={settings?.globalSettings}
          style={{
            marginBottom: "20px", // Adds space below the image
          }}
        />
        <div
          className="buttondds-container-responsivee"
          style={{
            display: "flex",
            flexDirection:
              numColumns === "center-single-row" ? "row" : "column",
            alignItems: "center",
            justifyContent: "center",
            // width: "100%",
            gap: getResponsivePadding(),
            flexWrap: "wrap",
            marginTop: "2vw",
          }}
        >
          {renderButtons()}
        </div>
        <AnimatePresence mode="wait">
          <motion.div
            //className="video-container"
            {...motionProps}
          >
            <img
              src={uploadedUrls?.centerBelowMenuMedia?.fileUrl}
              alt="Logo"
              style={{
                marginTop: "30px",
                display: uploadedUrls?.centerBelowMenuMedia?.enabled
                  ? "block"
                  : "none",
                width:
                  uploadedUrls?.centerBelowMenuMedia?.width > 0
                    ? `${uploadedUrls.centerBelowMenuMedia.width}%`
                    : "auto",
                height: "auto",
                // maxHeight: "140px"
              }}
            />
          </motion.div>
        </AnimatePresence>
      </motion.div>

      <Dialog
        open={editOpen}
        onClose={modalClodeFun}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: '#FFFFFF', // White modal background
            border: `2px solid ${brandColor}`,
            // padding: `${padding}px`,
            padding: `2vw`,
            borderRadius: '20px',
            width: '35vw',
            maxWidth: '70vw',
            // height:"auto"
            // marginLeft:`${triviaQuizSettings?.quizsetting?.leftoffset}%`
          },
          '& .MuiBackdrop-root': {
            backgroundColor: 'transparent', // Change this to any color (Example: Red with opacity)
          },
          // "& .MuiDialog-container": {
          //  marginLeft:`${triviaQuizSettings?.quizsetting?.leftoffset}%`,
          //  justifyContent: "unset", // Remove justify-content
          // WebkitJustifyContent: "unset", // Remove -webkit-justify-content
          // },
        }}
      >
        <DialogTitle
          style={{
            textAlign: 'center',
            // fontSize:`${fontSize}px`,
            fontSize: `3vw`,
            fontFamily: brandFont,
            // lineHeight:lineHeight
          }}
        >
          Are You There?
        </DialogTitle>

        <DialogTitle
          style={{
            textAlign: 'center',
            // fontSize:`${fontSize}px`,
            fontSize: `3vw`,
            fontFamily: brandFont,
            // lineHeight:lineHeight
          }}
        >
          {countdown}
        </DialogTitle>
        <DialogActions>
          <button
            style={{
              margin: '0 auto',
              background: brandColor,
              fontFamily: brandFont,
              fontSize: `2vw`,
              height: 'auto',
              maxHeight: '10vw',
              padding: '0.5vw 1vw',
            }}
            onClick={modalClodeFun}
          >
            Yes
          </button>
        </DialogActions>
      </Dialog>

      {/* Language Loading Overlay */}
      {isLanguageLoading && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 99999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.5vw' }}>
            {/* Spinner ring */}
            <div
              style={{
                width: '6vw',
                height: '6vw',
                borderRadius: '50%',
                border: '0.4vw solid rgba(255,255,255,0.2)',
                borderTopColor: '#ffffff',
                animation: 'languageSpinnerRotate 0.8s linear infinite',
              }}
            />
            {/* Dots */}
            <div style={{ display: 'flex', gap: '0.6vw' }}>
              {[0, 1, 2].map((i) => (
                <div
                  key={i}
                  style={{
                    width: '0.8vw',
                    height: '0.8vw',
                    borderRadius: '50%',
                    backgroundColor: '#ffffff',
                    animation: `languageSpinnerBounce 1.2s ease-in-out ${i * 0.2}s infinite`,
                    opacity: 0.8,
                  }}
                />
              ))}
            </div>
          </div>
          <style>{`
            @keyframes languageSpinnerRotate {
              to { transform: rotate(360deg); }
            }
            @keyframes languageSpinnerBounce {
              0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
              40% { transform: scale(1); opacity: 1; }
            }
          `}</style>
        </div>
      )}
    </div>
  );
};
export default MenuCatalouges;